import { Input } from '@weareopenr/component-library';
import { UseFormRegister } from 'react-hook-form';
import { IPriceBandFields } from 'src/types/priceRules';

type PriceBandNameProps = {
  error?: string;
  isCreate: boolean;
  priceBandNames: string[];
  register: UseFormRegister<IPriceBandFields>;
};

const isNameUnique = (value: string, isCreate: boolean, priceBandNames: string[]) => {
  // This needs to be updated when editing is enabled
  if (!isCreate) {
    return true;
  }

  const isUnique = !priceBandNames.includes(value.toLocaleLowerCase().trim());
  return isUnique ? true : 'A price band with this name already exists';
};

const PriceBandName = ({ isCreate = true, priceBandNames, error, register }: PriceBandNameProps) => {
  return (
    <Input
      type="text"
      label="Price Band Name"
      hasMargin
      register={register('name', {
        required: 'Please enter a name',
        validate: (value) => isNameUnique(value, isCreate, priceBandNames),
      })}
      error={error}
    />
  );
};

export default PriceBandName;
